// extracted by mini-css-extract-plugin
module.exports = {"likeButtonContents":"like-button-contents_likeButtonContents__5vxJM"};